/**
 * Contenu éditorial de la page /evenements (hub réceptions & privatisation).
 * Texte fourni par le client — à utiliser tel quel côté FR.
 */

export const EVENEMENTS_CONTENT = {
  fr: {
    meta: {
      title: "Privatisation & réceptions à Ville-d'Avray (92)",
      description:
        "Privatisez un hôtel particulier à Ville-d'Avray pour votre mariage, séminaire, baptême ou anniversaire : de 12 à 100 convives, 2 salons, terrasse sur parc, cuisine 100 % maison.",
      keywords:
        "privatisation Ville d'Avray, réception privée 92, mariage Ville d'Avray, séminaire Hauts-de-Seine, baptême, anniversaire, devis réception",
    },
    overline: "Réceptions privées · Ville-d'Avray (92)",
    h1: "Réceptions privées et privatisation à Ville-d'Avray",
    intro:
      "Installé dans un hôtel particulier du XIXe siècle, entre Saint-Cloud et Versailles et à 15 minutes de Paris, L'Entracte accueille vos événements privés et professionnels de 12 à 100 convives. Grand Salon, Petit Salon, terrasse de 240 m² surplombant un parc arboré : Michel et son équipe privatisent tout ou partie de l'établissement et vous proposent une formule clé en main, avec une cuisine entièrement faite maison à partir de produits frais.",
    ctaDevis: "Demander un devis",
    ctaCall: "Appeler le 01 82 00 18 67",
    heroAlt: "Terrasse de L'Entracte dressée pour une réception privée à Ville-d'Avray",

    brief: {
      title: "L'Entracte en bref",
      caption: "Informations pratiques de L'Entracte pour vos réceptions",
      rows: [
        ["Adresse", "3 rue de Versailles, 92410 Ville-d'Avray (Hauts-de-Seine)"],
        ["Capacité", "De 12 à 100 convives assis, jusqu'à 130 en cocktail"],
        ["Espaces", "Grand Salon, Petit Salon et terrasse de 240 m² sur parc"],
        ["Formule", "Clé en main : privatisation, repas du chef, boissons, service et décoration"],
        [
          "Tarifs indicatifs",
          "Réception clé en main à partir de 99 € TTC par personne · Séminaire dès 90 € HT",
        ],
        [
          "Horaires",
          "12h30-15h30 ou 19h30-22h30 (3 h incluses, modulables), heures supplémentaires 400 € de l'heure, fin au plus tard à minuit",
        ],
        ["Accès", "Gare de Sèvres – Ville-d'Avray (Transilien L et U) à 1 km · 15 minutes de Paris en voiture"],
        ["Accessibilité", "Espaces accessibles aux personnes à mobilité réduite"],
        ["Ouverture", "Toute l'année"],
      ],
    },

    cardsTitle: "Quel événement organisez-vous ?",
    cards: [
      {
        to: "/mariage",
        title: "Mariage",
        body:
          "Vin d'honneur au champagne sur la terrasse, dîner assis préparé par le chef, Saint-Honoré « comme une pièce montée » : un mariage à taille humaine, jusqu'à 100 invités assis. Menus de mariage de 99 à 125 € par invité.",
        cta: "Organiser mon mariage",
        alt: "Table de mariage dressée à L'Entracte",
      },
      {
        to: "/seminaire",
        title: "Séminaire et événement d'entreprise",
        body:
          "Demi-journée d'étude à 90 € HT et journée d'étude à 110 € HT par personne, déjeuner inclus, dès 12 participants et jusqu'à 80 en configuration théâtre. La gare, desservie par les lignes L et U, relie directement La Défense.",
        cta: "Organiser mon séminaire",
        alt: "Salle de séminaire privatisée à L'Entracte, Ville-d'Avray",
      },
      {
        to: "/bapteme",
        title: "Baptême et communion",
        body:
          "Un déjeuner de famille dans un salon privatisé ou sur la terrasse, avec un menu enfant (plat et dessert) à 40 €.",
        cta: "Organiser mon baptême",
        alt: "Déjeuner de baptême en famille à L'Entracte",
      },
      {
        to: "/anniversaire",
        title: "Anniversaire et fête de famille",
        body:
          "Dîner assis dès 50 € HT par personne ou cocktail dînatoire dès 70 € HT : anniversaires, fiançailles, noces, départs en retraite, dans un lieu rien que pour vous.",
        cta: "Organiser mon anniversaire",
        alt: "Dîner d'anniversaire privatisé à L'Entracte",
      },
    ],

    spaces: {
      title: "Nos espaces",
      items: [
        {
          name: "Le Grand Salon",
          body:
            "De 30 à 65 convives assis, jusqu'à 75 en cocktail. Lumineux, décoré avec soin, il accueille les dîners assis, les réunions et les réceptions en toute saison.",
          alt: "Grand Salon de L'Entracte dressé pour un dîner de réception",
        },
        {
          name: "Le Petit Salon",
          body:
            "De 10 à 30 convives. L'espace idéal pour un déjeuner de famille, un comité de direction ou une fête en petit comité.",
          alt: "Petit Salon de L'Entracte pour un déjeuner privatisé",
        },
        {
          name: "La terrasse de 240 m²",
          body:
            "Jusqu'à 90 convives assis et 120 en cocktail. Nichée dans un écrin de verdure, elle surplombe un parc arboré : c'est l'espace des vins d'honneur, des cocktails et des dîners d'été, utilisable lorsque la météo le permet.",
          alt: "Terrasse de 240 m² de L'Entracte surplombant le parc",
        },
        {
          name: "La privatisation totale",
          body:
            "De 50 à 100 convives assis, jusqu'à 130 en cocktail : tout l'établissement vous est réservé.",
          alt: "Établissement L'Entracte entièrement privatisé pour une réception",
        },
      ],
    },

    capacityTable: {
      title: "Quel espace pour combien d'invités ?",
      caption: "Espace privatisé selon le nombre d'invités adultes",
      head: ["Nombre d'invités adultes", "Espace privatisé"],
      rows: [
        ["De 12 à 29", "Le Petit Salon"],
        ["De 30 à 49", "Le Grand Salon"],
        ["50 et plus (avec cocktail apéritif)", "L'établissement entier"],
      ],
    },

    formula: {
      title: "La formule clé en main",
      includedTitle: "Inclus dans la réception clé en main :",
      included: [
        "La privatisation de l'espace adapté à votre nombre d'invités, pour 3 heures (12h30-15h30 ou 19h30-22h30, horaires modulables).",
        "Un repas assis en 3 plats : vous choisissez 2 entrées, 2 plats et 2 desserts dans notre carte événementielle.",
        "Les eaux plate et gazeuse, une bouteille de vin pour 4 personnes (ou des softs sur table) et le café.",
        "Le service et la mise en place de la salle.",
      ],
      price:
        "Tarif : 100 € TTC par personne, hors options, sur la base de 30 convives adultes avec cocktail apéritif.",
      optionsTitle: "Options :",
      options: [
        "Cocktail apéritif : 30 € par personne (5 pièces cocktail avec une flûte de champagne, ou un cocktail sans alcool, et softs).",
        "Assiette de 3 fromages affinés : 10 € par personne.",
        "Menu enfant (plat et dessert) : 40 €.",
        "Heure supplémentaire : 400 €.",
      ],
      othersTitle: "Autres formats :",
      others: [
        "Déjeuner ou dîner assis (entrée, plat, dessert, eau et café) : dès 50 € HT par personne.",
        "Cocktail dînatoire (15 pièces par personne, une bouteille de vin pour 3) : dès 70 € HT par personne, à partir de 15 invités.",
        "Séminaire : demi-journée d'étude dès 90 € HT, journée d'étude dès 110 € HT par personne, à partir de 12 participants.",
      ],
    },

    carte: {
      title: "Un aperçu de notre carte événementielle",
      intro:
        "Notre cuisine, traditionnelle et créative, est exclusivement élaborée à partir de produits frais et entièrement faite maison. Quelques propositions de la carte événementielle :",
      groups: [
        {
          label: "Entrées",
          body:
            "saumon gravlax mariné 24 h au sel de Guérande et au poivre de Sichuan ; trio de ravioles Saint-Jacques, cabillaud et crevette, sauce crustacés ; œuf nuage, crème forestière aux morilles ; foie gras mi-cuit, compotée d'oignons et toast brioché ; ballottine de légumes, sauce gingembre-miel (végétarien).",
        },
        {
          label: "Plats",
          body:
            "filet de bar juste snacké, tian de légumes de saison ; cuisse de canard confite, sauce bordelaise ; filet mignon de veau, gratin de légumes et sauce champignons ; risotto crémeux à l'encre de seiche et gambas flambées au whisky (version végétarienne aux champignons).",
        },
        {
          label: "Desserts",
          body:
            "Saint-Honoré « comme une pièce montée » ; tarte Tatin du chef ; pavlova à l'orange ; cœur fondant au chocolat et glace vanille.",
        },
      ],
      note: "Menus végétariens, vegan, sans gluten, halal ou biologiques sur demande.",
      alt: "Plat de la carte événementielle de L'Entracte",
    },

    process: {
      title: "Comment se déroule l'organisation ?",
      steps: [
        "Vous nous envoyez votre demande : type d'événement, date, nombre d'invités. Nous répondons généralement sous 24 heures.",
        "Nous échangeons sur votre projet et vous proposons une visite du lieu.",
        "Vous validez le devis, avec un acompte de 50 % à la signature.",
        "Dix jours avant l'événement, vous nous confirmez le nombre de convives (adultes et enfants), vos choix de menus et votre heure d'arrivée.",
        "Le jour J, le solde est réglé avant la prestation (chèque ou virement), et notre équipe coordonne le service du début à la fin.",
      ],
    },

    goodToKnow: {
      title: "Bon à savoir",
      items: [
        "Pas de location de salle seule : la restauration est toujours assurée par notre cuisine, et les boissons extérieures ne sont pas acceptées.",
        "Photographe libre : vous choisissez le prestataire de votre choix.",
        "Le gâteau : le chef peut réaliser votre dessert de fête, et vous pouvez aussi apporter votre propre gâteau (conditions précisées dans le devis).",
        "Des réceptions autour de la table : le lieu n'a pas de piste de danse dédiée, et les événements se terminent au plus tard à minuit.",
        "Privatisation partielle ou totale : en privatisation partielle, d'autres clients peuvent être reçus dans les autres espaces. Pour un lieu rien qu'à vous, choisissez la privatisation totale.",
      ],
    },

    access: {
      title: "Accès",
      intro:
        "L'Entracte se trouve au 3 rue de Versailles, à Ville-d'Avray (Hauts-de-Seine), entre Saint-Cloud et Versailles, à 15 minutes de Paris.",
      items: [
        "En train : gare de Sèvres – Ville-d'Avray à 1 km (environ 13 minutes à pied), desservie par la ligne L (depuis Paris Saint-Lazare et La Défense) et la ligne U (depuis La Défense).",
        "En bus : arrêt à proximité du restaurant.",
        "En voiture : stationnement à proximité immédiate du restaurant.",
        "Depuis les aéroports : environ 30 minutes d'Orly et 45 minutes de Roissy-Charles-de-Gaulle.",
        "Hébergement des invités : l'hôtel Campanile Paris Ouest – Chaville (128 chambres) se trouve à 1 km.",
      ],
    },

    reviews: {
      title: "Ils ont célébré à L'Entracte",
      ratings: "5/5 sur Mariages.net · 5/5 sur 1001 Salles (7 avis) · 4,7/5 sur Kactus (10 avis)",
      quotes: [
        {
          quote: "Très bonne communication en amont, grande flexibilité. Repas et services impeccables.",
          author: "Pierre, mariage (Mariages.net, septembre 2023)",
        },
        {
          quote: "Les plats étaient délicieux et très bien présentés.",
          author: "Sam, mariage (1001 Salles, juillet 2023)",
        },
        {
          quote: "Un dîner de qualité dans un très beau cadre.",
          author: "Entreprise cliente, dîner de cohésion (Kactus, juin 2026)",
        },
      ],
    },

    faqTitle: "Questions fréquentes",
    faq: [
      {
        question: "Combien de personnes pouvez-vous accueillir ?",
        answer:
          "De 12 à 100 convives assis, et jusqu'à 130 en cocktail en privatisation totale. Le Petit Salon reçoit de 10 à 30 personnes, le Grand Salon de 30 à 65 assis et la terrasse jusqu'à 90 assis.",
      },
      {
        question: "Quel espace sera privatisé pour mon événement ?",
        answer:
          "Il dépend du nombre d'invités adultes : le Petit Salon en dessous de 30, le Grand Salon de 30 à 49, et l'établissement entier à partir de 50 invités avec cocktail apéritif.",
      },
      {
        question: "Peut-on louer la salle sans la restauration ?",
        answer:
          "Non. Toutes nos réceptions incluent la cuisine du chef ; la location de salle seule n'est pas proposée.",
      },
      {
        question: "Quel budget prévoir ?",
        answer:
          "La réception clé en main (repas 3 plats, vin, eaux et café) est à 100 € TTC par personne, hors options. Le cocktail apéritif est en option à 30 € par personne. Pour les entreprises, le déjeuner ou dîner assis démarre à 50 € HT, le cocktail dînatoire à 70 € HT et la demi-journée de séminaire à 90 € HT par personne.",
      },
      {
        question: "Jusqu'à quelle heure peut durer la réception ?",
        answer:
          "La formule comprend 3 heures de prestation (12h30-15h30 ou 19h30-22h30, modulables). Les heures supplémentaires sont facturées 400 € de l'heure, et les événements se terminent au plus tard à minuit.",
      },
      {
        question: "Peut-on apporter nos propres boissons ?",
        answer:
          "Non. Les boissons sont incluses dans le menu (une bouteille de vin pour 4 personnes, eaux et café) ; les consommations supplémentaires sont réglées sur place.",
      },
      {
        question: "Proposez-vous des menus adaptés ?",
        answer:
          "Oui : menus végétariens, vegan, sans gluten, halal ou biologiques sur demande, ainsi qu'un menu enfant (plat et dessert) à 40 €.",
      },
      {
        question: "Le lieu est-il accessible aux personnes à mobilité réduite ?",
        answer: "Oui, nos espaces sont accessibles aux personnes à mobilité réduite.",
      },
      {
        question: "Comment venir en transports en commun ?",
        answer:
          "La gare de Sèvres – Ville-d'Avray, à 1 km, est desservie par la ligne L depuis Paris Saint-Lazare et La Défense, et par la ligne U depuis La Défense. Un arrêt de bus se trouve à proximité.",
      },
      {
        question: "Où loger nos invités ?",
        answer:
          "L'hôtel Campanile Paris Ouest – Chaville, à 1 km, compte 128 chambres. L'Entracte ne dispose pas de chambres.",
      },
      {
        question: "Quelles sont les modalités de réservation ?",
        answer:
          "Un acompte de 50 % est demandé à la signature du devis, et le solde est réglé le jour J avant la prestation, par chèque ou virement. Le nombre définitif de convives et les choix de menus sont à confirmer 10 jours avant l'événement.",
      },
    ],

    devis: {
      title: "Demandez votre devis",
      body:
        "Décrivez-nous votre projet : nous revenons généralement vers vous sous 24 heures avec une proposition adaptée.",
      contact: "Téléphone : 01 82 00 18 67 · E-mail : restaurantlentractevda@gmail.com",
    },
  },

  en: {
    meta: {
      title: "Private hire & receptions in Ville-d'Avray (92)",
      description:
        "Hire a private townhouse in Ville-d'Avray for your wedding, seminar, christening or birthday: 12 to 100 guests, 2 lounges, terrace overlooking a park, 100% house-made cuisine.",
      keywords:
        "venue hire Ville d'Avray, private reception 92, wedding venue Ville d'Avray, corporate seminar Hauts-de-Seine, christening, birthday, reception quote",
    },
    overline: "Private receptions · Ville-d'Avray (92)",
    h1: "Private receptions and venue hire in Ville-d'Avray",
    intro:
      "Set in a 19th-century private townhouse between Saint-Cloud and Versailles, 15 minutes from Paris, L'Entracte hosts your private and corporate events for 12 to 100 guests. Grand Salon, Petit Salon and a 240 m² terrace overlooking a wooded park: Michel and his team hire out all or part of the venue and offer a turnkey package, with cuisine made entirely in-house from fresh produce.",
    ctaDevis: "Request a quote",
    ctaCall: "Call +33 1 82 00 18 67",
    heroAlt: "L'Entracte terrace set for a private reception in Ville-d'Avray",

    brief: {
      title: "L'Entracte at a glance",
      caption: "Key practical information about L'Entracte for your receptions",
      rows: [
        ["Address", "3 rue de Versailles, 92410 Ville-d'Avray (Hauts-de-Seine)"],
        ["Capacity", "12 to 100 seated guests, up to 130 for a cocktail reception"],
        ["Spaces", "Grand Salon, Petit Salon and a 240 m² terrace overlooking the park"],
        ["Package", "Turnkey: venue hire, the chef's menu, drinks, service and decoration"],
        [
          "Indicative rates",
          "Turnkey reception from €99 incl. VAT per person · Seminar from €90 excl. VAT",
        ],
        [
          "Timings",
          "12.30-3.30pm or 7.30-10.30pm (3 hours included, flexible), extra hours €400 per hour, events end by midnight at the latest",
        ],
        ["Getting here", "Sèvres – Ville-d'Avray station (Transilien lines L and U) 1 km away · 15 minutes from Paris by car"],
        ["Accessibility", "Spaces accessible to guests with reduced mobility"],
        ["Open", "All year round"],
      ],
    },

    cardsTitle: "What kind of event are you planning?",
    cards: [
      {
        to: "/mariage",
        title: "Wedding",
        body:
          "Champagne reception on the terrace, seated dinner prepared by the chef, a Saint-Honoré served \"like a wedding cake\": an intimate wedding for up to 100 seated guests. Wedding menus from €99 to €125 per guest.",
        cta: "Plan my wedding",
        alt: "Wedding table set at L'Entracte",
      },
      {
        to: "/seminaire",
        title: "Seminars and corporate events",
        body:
          "Half-day meeting package at €90 excl. VAT and full-day at €110 excl. VAT per person, lunch included, from 12 participants and up to 80 in theatre layout. The station, served by lines L and U, connects directly to La Défense.",
        cta: "Plan my seminar",
        alt: "Private seminar room at L'Entracte, Ville-d'Avray",
      },
      {
        to: "/bapteme",
        title: "Christenings and communions",
        body:
          "A family lunch in a private lounge or on the terrace, with a children's menu (main course and dessert) at €40.",
        cta: "Plan my christening",
        alt: "Family christening lunch at L'Entracte",
      },
      {
        to: "/anniversaire",
        title: "Birthdays and family celebrations",
        body:
          "Seated dinner from €50 excl. VAT per person or standing dinner cocktail from €70 excl. VAT: birthdays, engagements, wedding anniversaries and retirement parties, in a venue that is all yours.",
        cta: "Plan my birthday",
        alt: "Private birthday dinner at L'Entracte",
      },
    ],

    spaces: {
      title: "Our spaces",
      items: [
        {
          name: "The Grand Salon",
          body:
            "30 to 65 seated guests, up to 75 for a cocktail reception. Bright and carefully decorated, it hosts seated dinners, meetings and receptions all year round.",
          alt: "Grand Salon at L'Entracte set for a reception dinner",
        },
        {
          name: "The Petit Salon",
          body:
            "10 to 30 guests. The ideal space for a family lunch, a board meeting or a small celebration.",
          alt: "Petit Salon at L'Entracte for a private lunch",
        },
        {
          name: "The 240 m² terrace",
          body:
            "Up to 90 seated guests and 120 for a cocktail reception. Nestled in greenery, it overlooks a wooded park: the place for champagne receptions, cocktails and summer dinners, weather permitting.",
          alt: "L'Entracte's 240 m² terrace overlooking the park",
        },
        {
          name: "Full venue hire",
          body: "50 to 100 seated guests, up to 130 for a cocktail reception: the whole venue is yours.",
          alt: "L'Entracte fully hired out for a private reception",
        },
      ],
    },

    capacityTable: {
      title: "Which space for how many guests?",
      caption: "Private space allocated according to the number of adult guests",
      head: ["Number of adult guests", "Space hired"],
      rows: [
        ["12 to 29", "The Petit Salon"],
        ["30 to 49", "The Grand Salon"],
        ["50 and more (with welcome cocktail)", "The entire venue"],
      ],
    },

    formula: {
      title: "The turnkey package",
      includedTitle: "Included in the turnkey reception:",
      included: [
        "Private hire of the space matching your number of guests, for 3 hours (12.30-3.30pm or 7.30-10.30pm, flexible timings).",
        "A seated 3-course meal: you choose 2 starters, 2 main courses and 2 desserts from our events menu.",
        "Still and sparkling water, one bottle of wine for 4 people (or soft drinks on the table) and coffee.",
        "Service and room set-up.",
      ],
      price:
        "Rate: €100 incl. VAT per person, excluding options, based on 30 adult guests with a welcome cocktail.",
      optionsTitle: "Options:",
      options: [
        "Welcome cocktail: €30 per person (5 canapés with a glass of champagne, or a non-alcoholic cocktail, plus soft drinks).",
        "Plate of 3 matured cheeses: €10 per person.",
        "Children's menu (main course and dessert): €40.",
        "Extra hour: €400.",
      ],
      othersTitle: "Other formats:",
      others: [
        "Seated lunch or dinner (starter, main course, dessert, water and coffee): from €50 excl. VAT per person.",
        "Standing dinner cocktail (15 canapés per person, one bottle of wine for 3): from €70 excl. VAT per person, from 15 guests.",
        "Seminar: half-day meeting package from €90 excl. VAT, full day from €110 excl. VAT per person, from 12 participants.",
      ],
    },

    carte: {
      title: "A taste of our events menu",
      intro:
        "Our traditional and creative cuisine is made exclusively from fresh produce and entirely in-house. A few suggestions from the events menu:",
      groups: [
        {
          label: "Starters",
          body:
            "gravlax salmon marinated for 24 hours in Guérande salt and Sichuan pepper; trio of ravioli with scallop, cod and prawn, shellfish sauce; cloud egg with woodland morel cream; semi-cooked foie gras, onion compote and brioche toast; vegetable ballotine, ginger and honey sauce (vegetarian).",
        },
        {
          label: "Main courses",
          body:
            "seared sea bass fillet, seasonal vegetable tian; confit duck leg, bordelaise sauce; veal fillet mignon, vegetable gratin and mushroom sauce; creamy squid-ink risotto with prawns flambéed in whisky (vegetarian version with mushrooms).",
        },
        {
          label: "Desserts",
          body:
            "Saint-Honoré served \"like a wedding cake\"; the chef's tarte Tatin; orange pavlova; molten chocolate cake with vanilla ice cream.",
        },
      ],
      note: "Vegetarian, vegan, gluten-free, halal or organic menus on request.",
      alt: "Dish from L'Entracte's events menu",
    },

    process: {
      title: "How does the planning work?",
      steps: [
        "You send us your enquiry: type of event, date, number of guests. We usually reply within 24 hours.",
        "We discuss your project and invite you to visit the venue.",
        "You approve the quote, with a 50% deposit on signature.",
        "Ten days before the event, you confirm the number of guests (adults and children), your menu choices and your arrival time.",
        "On the day, the balance is settled before the service (cheque or bank transfer), and our team coordinates the service from start to finish.",
      ],
    },

    goodToKnow: {
      title: "Good to know",
      items: [
        "No room-only hire: catering is always provided by our kitchen, and outside drinks are not permitted.",
        "Free choice of photographer: you pick the supplier you prefer.",
        "The cake: the chef can create your celebration dessert, and you may also bring your own cake (conditions set out in the quote).",
        "Receptions around the table: the venue has no dedicated dance floor, and events end by midnight at the latest.",
        "Partial or full hire: with partial hire, other guests may be welcomed in the remaining spaces. For a venue entirely to yourself, choose full hire.",
      ],
    },

    access: {
      title: "Getting here",
      intro:
        "L'Entracte is located at 3 rue de Versailles in Ville-d'Avray (Hauts-de-Seine), between Saint-Cloud and Versailles, 15 minutes from Paris.",
      items: [
        "By train: Sèvres – Ville-d'Avray station 1 km away (about a 13-minute walk), served by line L (from Paris Saint-Lazare and La Défense) and line U (from La Défense).",
        "By bus: stop close to the restaurant.",
        "By car: parking in the immediate vicinity of the restaurant.",
        "From the airports: about 30 minutes from Orly and 45 minutes from Roissy-Charles-de-Gaulle.",
        "Accommodation for guests: the Campanile Paris Ouest – Chaville hotel (128 rooms) is 1 km away.",
      ],
    },

    reviews: {
      title: "They celebrated at L'Entracte",
      ratings: "5/5 on Mariages.net · 5/5 on 1001 Salles (7 reviews) · 4.7/5 on Kactus (10 reviews)",
      quotes: [
        {
          quote: "Excellent communication beforehand and great flexibility. Impeccable food and service.",
          author: "Pierre, wedding (Mariages.net, September 2023)",
        },
        {
          quote: "The dishes were delicious and beautifully presented.",
          author: "Sam, wedding (1001 Salles, July 2023)",
        },
        {
          quote: "A quality dinner in a very beautiful setting.",
          author: "Corporate client, team dinner (Kactus, June 2026)",
        },
      ],
    },

    faqTitle: "Frequently asked questions",
    faq: [
      {
        question: "How many guests can you host?",
        answer:
          "From 12 to 100 seated guests, and up to 130 for a cocktail reception with full venue hire. The Petit Salon hosts 10 to 30 people, the Grand Salon 30 to 65 seated and the terrace up to 90 seated.",
      },
      {
        question: "Which space will be hired for my event?",
        answer:
          "It depends on the number of adult guests: the Petit Salon below 30, the Grand Salon from 30 to 49, and the entire venue from 50 guests with a welcome cocktail.",
      },
      {
        question: "Can we hire the room without catering?",
        answer:
          "No. All our receptions include the chef's cuisine; room-only hire is not offered.",
      },
      {
        question: "What budget should we plan for?",
        answer:
          "The turnkey reception (3-course meal, wine, water and coffee) is €100 incl. VAT per person, excluding options. The welcome cocktail is an option at €30 per person. For companies, a seated lunch or dinner starts at €50 excl. VAT, the standing dinner cocktail at €70 excl. VAT and the half-day seminar at €90 excl. VAT per person.",
      },
      {
        question: "How late can the reception run?",
        answer:
          "The package includes 3 hours of service (12.30-3.30pm or 7.30-10.30pm, flexible). Extra hours are charged at €400 per hour, and events end by midnight at the latest.",
      },
      {
        question: "Can we bring our own drinks?",
        answer:
          "No. Drinks are included in the menu (one bottle of wine for 4 people, water and coffee); additional consumption is settled on site.",
      },
      {
        question: "Do you offer special diet menus?",
        answer:
          "Yes: vegetarian, vegan, gluten-free, halal or organic menus on request, as well as a children's menu (main course and dessert) at €40.",
      },
      {
        question: "Is the venue accessible to guests with reduced mobility?",
        answer: "Yes, our spaces are accessible to guests with reduced mobility.",
      },
      {
        question: "How do we get here by public transport?",
        answer:
          "Sèvres – Ville-d'Avray station, 1 km away, is served by line L from Paris Saint-Lazare and La Défense, and by line U from La Défense. There is a bus stop nearby.",
      },
      {
        question: "Where can our guests stay?",
        answer:
          "The Campanile Paris Ouest – Chaville hotel, 1 km away, has 128 rooms. L'Entracte does not have guest rooms.",
      },
      {
        question: "What are the booking terms?",
        answer:
          "A 50% deposit is required on signature of the quote, and the balance is settled on the day before the service, by cheque or bank transfer. The final number of guests and the menu choices are to be confirmed 10 days before the event.",
      },
    ],

    devis: {
      title: "Request your quote",
      body:
        "Tell us about your project: we usually get back to you within 24 hours with a tailored proposal.",
      contact: "Phone: +33 1 82 00 18 67 · Email: restaurantlentractevda@gmail.com",
    },
  },
};
